
import { getFirstHeading, removeFirstHeading } from '~/fc/Helpers/DOMHelper'
export default {
  name: 'ContentCardHTML',
  components: {
    Accordion: () => import('~/components/ui/AccordionSingle')
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    content: {
      required: true,
      default: () => ([])
    },
    // eslint-disable-next-line vue/require-prop-types
    title: {
      required: false,
      default: ''
    },
    openedInitially: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    cardTitle: '',
    cardContent: ''
  }),
  watch: {
    content (val) {
      this.extractTitleAndContent()
    }
  },
  created () {
    this.extractTitleAndContent()
  },
  methods: {
    extractTitleAndContent () {
      if (!(this.content && this.content.length)) { return false }
      const firstHeader = getFirstHeading(this.content)
      this.cardTitle = this.title || firstHeader
      this.cardContent = firstHeader ? removeFirstHeading(this.content) : this.content
    }
  }
}
